export enum FormatType {
    Date,
    Number,
    Currency,
    String,
    Custom
}



// WEBPACK FOOTER //
// ./src/app/main/feeds/shared/models/format-type.model.ts